export const BENEFIT_NAME_MAX = 50;
export const SHORT_DESCRIPTION_MAX = 300;
export const DESCRIPTION_MAX = 5000;
export const BUTTON_LABEL_MAX = 50;

export type CategoryDropdownOption = {
  value: string;
  text: string;
  isNew?: boolean;
};

export interface BasicInformationFieldsProps {
  onOpenAddCategoryModal: () => void;
  optionsCategory: CategoryDropdownOption[];
}

export interface CategoryDropdownProps {
  onOpenAddCategoryModal: () => void;
  optionsCategory: CategoryDropdownOption[];
  selectedCategoryIds?: string[];
}
